import { MRP, ApiResponse } from '@/models';
import BaseService from '@/utils/base-service';

export class MRPService extends BaseService {
    private endpoint = '/resultsets/mrp';

    constructor() {
        super(process.env.VUE_APP_API_BASE_URL);
    }
    public async get(sno: number): Promise<ApiResponse<MRP>> {
        return (await this.api.get(`${this.endpoint}/${sno}`)).data;
    }
}
